export default function reportPackageDirective() {
  return {
    template: require('./report-package.html'),
    controller: 'PRReportPackageController',
    controllerAs: 'prReportPackageVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportPackage: '=',
    },
  };
}
